import { parseState } from './debug.parse.browser.js';

const debugGetState = () => {
    try {
        return parseState(window.localStorage.getItem('debug'));
    }
    catch (e) { }
};

export { debugGetState };
